import { useTranslations } from 'next-intl';

type LabelProps = {
  label: string;
  htmlFor: string;
  required?: boolean;
  requiredVariant?: 'asterisk' | 'badge';
  color?: string;
  textSize?: 'text-label-16' | 'text-label-14';
};

const Label = ({
  label,
  htmlFor,
  required = false,
  requiredVariant = 'asterisk',
  color = 'text-gray-900',
  textSize = 'text-label-16',
}: LabelProps) => {
  const t = useTranslations();

  return (
    <label htmlFor={htmlFor} className={`block ${textSize} ${color}`}>
      {label}
      {required && requiredVariant === 'asterisk' && <span className='ml-0.5 text-kl-red'>*</span>}
      {required && requiredVariant === 'badge' && (
        <span className='text-badge-12 bg-func-attention ml-2 px-1 py-[0.2rem] text-white'>
          {t('common-required')}
        </span>
      )}
    </label>
  );
};
export default Label;
